import { BottomPanelContextProvider } from '@ubnt/link-core-ui/components/BottomPanel/context/BottomPanelContext';
import { useSelector } from 'app/store';
import { activeElementLinkIdSelector } from 'modules/activeElement/externalSelectors';
import { linksLinkApIdSelector, linksLinkClientIdSelector } from 'modules/links/slice';

import BottomDrawer from 'components/BottomDrawer/BottomDrawer';
import WifiBottomMobilePanel from 'modules/bottomPanel/components/compositions/WifiBottomPanelMobile';

const WifiBottomPanelMobileContainer = () => {
  const linkId = useSelector(activeElementLinkIdSelector);
  const apId = useSelector((state) => linksLinkApIdSelector(state, linkId));
  const clientId = useSelector((state) => linksLinkClientIdSelector(state, linkId));

  if (!apId || !clientId) {
    return null;
  }

  return (
    <BottomDrawer>
      <BottomPanelContextProvider leftId={apId} linkId={linkId} rightId={clientId}>
        <WifiBottomMobilePanel />
      </BottomPanelContextProvider>
    </BottomDrawer>
  );
};

export default WifiBottomPanelMobileContainer;
